import type { IconData } from '@stacksjs/iconify-core'

export const browser: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M472 40H40a24.03 24.03 0 0 0-24 24v384a24.03 24.03 0 0 0 24 24h432a24.03 24.03 0 0 0 24-24V64a24.03 24.03 0 0 0-24-24M48 72h96v72H48Zm416 368H48V176h416Zm0-296H176V72h288Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default browser
